<template>
  <div class="svg-box">
    <svg
      version="1.1"
      v-if="svgName === 'shoppingCart'"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 27 24"
      :width="width || '27px'"
      :height="height || '24px'"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="matrix(1 0 0 1 -1065 -51 )">
        <path
          d="M 9.76802884615385 20.2840909090909  C 10.1790865384615 20.7159090909091  10.3846153846154 21.2272727272727  10.3846153846154 21.8181818181818  C 10.3846153846154 22.4090909090909  10.1790865384615 22.9204545454545  9.76802884615385 23.3522727272727  C 9.35697115384616 23.7840909090909  8.87019230769231 24  8.30769230769231 24  C 7.74519230769231 24  7.25841346153846 23.7840909090909  6.84735576923077 23.3522727272727  C 6.43629807692308 22.9204545454545  6.23076923076923 22.4090909090909  6.23076923076923 21.8181818181818  C 6.23076923076923 21.2272727272727  6.43629807692308 20.7159090909091  6.84735576923077 20.2840909090909  C 7.25841346153846 19.8522727272727  7.74519230769231 19.6363636363636  8.30769230769231 19.6363636363636  C 8.87019230769231 19.6363636363636  9.35697115384616 19.8522727272727  9.76802884615385 20.2840909090909  Z M 24.3064903846154 20.2840909090909  C 24.7175480769231 20.7159090909091  24.9230769230769 21.2272727272727  24.9230769230769 21.8181818181818  C 24.9230769230769 22.4090909090909  24.7175480769231 22.9204545454545  24.3064903846154 23.3522727272727  C 23.8954326923077 23.7840909090909  23.4086538461538 24  22.8461538461538 24  C 22.2836538461538 24  21.796875 23.7840909090909  21.3858173076923 23.3522727272727  C 20.9747596153846 22.9204545454545  20.7692307692308 22.4090909090909  20.7692307692308 21.8181818181818  C 20.7692307692308 21.2272727272727  20.9747596153846 20.7159090909091  21.3858173076923 20.2840909090909  C 21.796875 19.8522727272727  22.2836538461538 19.6363636363636  22.8461538461538 19.6363636363636  C 23.4086538461538 19.6363636363636  23.8954326923077 19.8522727272727  24.3064903846154 20.2840909090909  Z M 26.6917067307692 2.50568181818182  C 26.8972355769231 2.72159090909091  27 2.97727272727272  27 3.27272727272727  L 27 12  C 27 12.2727272727273  26.9107572115385 12.5142045454545  26.7322716346154 12.7244318181818  C 26.5537860576923 12.9346590909091  26.3347355769231 13.0568181818182  26.0751201923077 13.0909090909091  L 9.13521634615385 15.1704545454545  C 9.27584134615385 15.8522727272727  9.34615384615385 16.25  9.34615384615385 16.3636363636364  C 9.34615384615385 16.5454545454545  9.21634615384615 16.9090909090909  8.95673076923077 17  L 23.8846153846154 17  C 24.1658653846154 17.4545454545455  24.4092548076923 17.5625  24.6147836538462 17.7784090909091  C 24.8203125 17.9943181818182  24.9230769230769 18.25  24.9230769230769 18.5454545454545  C 24.9230769230769 18.8409090909091  24.8203125 19.0965909090909  24.6147836538462 19.3125  C 24.4092548076923 19.5284090909091  24.1658653846154 19.6363636363636  23.8846153846154 19.6363636363636  L 7.26923076923077 19.6363636363636  C 6.98798076923077 19.6363636363636  6.74459134615385 19.5284090909091  6.5390625 19.3125  C 6.33353365384615 19.0965909090909  6.23076923076923 18.8409090909091  6.23076923076923 18.5454545454545  C 6.23076923076923 18.4204545454545  6.27403846153846 18.2414772727273  6.36057692307692 18.0085227272727  C 6.44711538461539 17.7755681818182  6.53365384615385 17.5710227272727  6.62019230769231 17.3948863636364  C 6.70673076923077 17.21875  6.82301682692308 16.9914772727273  6.96905048076923 16.7130681818182  C 7.11508413461539 16.4346590909091  7.19891826923077 16.2670454545455  7.22055288461539 16.2102272727273  L 4.34855769230769 2.18181818181818  L 1.03846153846154 2.18181818181818  C 0.757211538461539 2.18181818181818  0.513822115384615 2.07386363636363  0.308293269230769 1.85795454545454  C 0.102764423076923 1.64204545454545  0 1.38636363636364  0 1.09090909090909  C 0 0.795454545454544  0.102764423076923 0.539772727272724  0.308293269230769 0.323863636363638  C 0.513822115384615 0.107954545454543  0.757211538461539 0  1.03846153846154 0  L 5.19230769230769 0  C 5.36538461538462 0  5.51953125 0.0369318181818166  5.65474759615385 0.110795454545455  C 5.78996394230769 0.184659090909091  5.89543269230769 0.272727272727272  5.97115384615385 0.375  C 6.046875 0.477272727272728  6.1171875 0.616477272727269  6.18209134615385 0.792613636363638  C 6.24699519230769 0.968749999999998  6.29026442307692 1.11647727272727  6.31189903846154 1.23579545454546  C 6.33353365384615 1.35511363636364  6.36328125 1.52272727272727  6.40114182692308 1.73863636363636  C 6.43900240384615 1.95454545454545  6.46334134615385 2.10227272727273  6.47415865384615 2.18181818181818  L 25.9615384615385 2.18181818181818  C 26.2427884615385 2.18181818181818  26.4861778846154 2.28977272727273  26.6917067307692 2.50568181818182  Z "
          fill-rule="nonzero"
          :fill="defaultFill || '#266fb7'"
          stroke="none"
          transform="matrix(1 0 0 1 1065 51 )"
        />
      </g>
    </svg>
    <svg
      version="1.0"
      v-if="svgName === 'userInfo'"
      xmlns="http://www.w3.org/2000/svg"
      :width="width || '27px'"
      :height="height || '24px'"
      viewBox="0 0 800.000000 800.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <metadata>
        <rdf:RDF
          xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
          xmlns:rdfs="http://www.w3.org/2000/01/rdf-schema#"
          xmlns:dc="http://purl.org/dc/elements/1.1/"
        >
          <rdf:Description
            dc:format="image/svg+xml"
            dc:Label="1"
            dc:ContentProducer="001191330110MACRLGPT8B00000"
            dc:ProduceID="312386812"
            dc:ReservedCode1="J1++adMAginNn+m33YP/PnBGvQSNn/ioJwy9o3Gi52M="
            dc:ContentPropagator="001191330110MACRLGPT8B00000"
            dc:PropagateID="312386812"
            dc:ReservedCode2="J1++adMAginNn+m33YP/PnBGvQSNn/ioJwy9o3Gi52M="
          />
        </rdf:RDF>
      </metadata>
      <g
        transform="translate(0.000000,800.000000) scale(0.100000,-0.100000)"
        :fill="defaultFill || '#266fb7'"
        stroke="none"
      >
        <path
          d="M3805 6179 c-681 -37 -1320 -429 -1671 -1025 -157 -267 -247 -533 -285 -837 -17 -142 -7 -441 21 -587 165 -883 833 -1548 1715 -1705 124 -22 443 -31 575 -16 315 36 634 145 880 301 525 332 877 865 970 1465 25 161 27 431 5 598 -55 419 -254 832 -554 1149 -105 110 -245 232 -285 248 -38 14 -91 -11 -105 -52 -16 -44 3 -76 89 -149 387 -326 637 -783 689 -1261 45 -410 -44 -836 -249 -1181 -199 -337 -503 -616 -847 -777 -261 -123 -521 -180 -818 -180 -323 0 -570 59 -855 202 -371 187 -661 470 -851 833 -89 169 -157 373 -195 581 -25 140 -25 478 0 619 100 556 448 1056 937 1346 115 68 175 97 304 144 221 81 353 105 605 112 320 9 530 -30 818 -154 110 -46 129 -48 170 -10 28 26 30 87 5 109 -50 44 -270 131 -438 173 -200 49 -396 66 -630 54z"
        />
        <path
          d="M3945 5026 c-45 -45 -30 -117 27 -134 20 -6 219 -10 502 -10 379 0 470 -3 477 -14 5 -7 9 -356 9 -775 l0 -763 -235 0 -236 0 -24 -25 c-15 -15 -25 -36 -25 -54 0 -85 20 -91 297 -91 242 0 285 6 332 46 64 53 62 26 59 909 l-3 800 -23 40 c-13 22 -39 52 -59 65 l-37 25 -518 3 -518 3 -25 -25z"
        />
        <path
          d="M3340 5004 c-287 -62 -481 -339 -442 -633 20 -147 110 -299 224 -375 l49 -33 -33 -14 c-234 -95 -430 -359 -463 -622 -9 -70 6 -111 46 -127 65 -28 113 10 122 97 27 259 244 494 507 549 271 57 571 -117 688 -399 17 -40 33 -88 36 -107 3 -19 8 -52 11 -73 3 -20 16 -46 27 -57 30 -28 91 -27 119 1 20 20 21 29 16 98 -6 94 -48 221 -106 319 -74 126 -196 240 -331 308 l-54 27 24 15 c42 27 135 126 164 174 117 200 105 453 -29 632 -84 113 -185 179 -329 216 -91 23 -154 24 -246 4z m180 -165 c126 -20 243 -109 298 -227 24 -50 27 -69 27 -162 0 -97 -2 -110 -31 -170 -39 -82 -110 -152 -194 -193 -59 -29 -74 -32 -155 -32 -128 1 -188 26 -281 119 -78 79 -110 142 -120 245 -20 188 127 383 317 420 61 12 66 12 139 0z"
        />
        <path
          d="M4203 4570 c-57 -23 -66 -100 -16 -140 24 -19 40 -20 299 -20 l272 0 31 26 c23 19 31 34 31 59 0 25 -8 40 -31 59 l-31 26 -266 -1 c-147 0 -277 -4 -289 -9z"
        />
        <path
          d="M4183 4218 c-33 -16 -48 -61 -33 -98 24 -58 41 -61 346 -58 l276 3 24 28 c38 45 31 98 -17 122 -23 12 -80 15 -301 14 -169 0 -281 -4 -295 -11z"
        />
        <path
          d="M4303 3841 c-59 -36 -51 -117 15 -142 15 -6 114 -9 243 -7 197 3 219 5 238 22 33 30 29 88 -10 120 l-31 26 -211 0 c-192 0 -215 -2 -244 -19z"
        />
      </g>
    </svg>
    <svg
      version="1.0"
      v-if="svgName === 'companyInfo'"
      xmlns="http://www.w3.org/2000/svg"
      :width="width || '27px'"
      :height="height || '24px'"
      viewBox="0 0 800.000000 800.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <metadata>
        <rdf:RDF
          xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
          xmlns:rdfs="http://www.w3.org/2000/01/rdf-schema#"
          xmlns:dc="http://purl.org/dc/elements/1.1/"
        >
          <rdf:Description
            dc:format="image/svg+xml"
            dc:Label="1"
            dc:ContentProducer="001191330110MACRLGPT8B00000"
            dc:ProduceID="312388581"
            dc:ReservedCode1="T46G1tu/aMl4JQoXA6ioPXON2CPPd/fsn2c9vrlIvnI="
            dc:ContentPropagator="001191330110MACRLGPT8B00000"
            dc:PropagateID="312388581"
            dc:ReservedCode2="T46G1tu/aMl4JQoXA6ioPXON2CPPd/fsn2c9vrlIvnI="
          />
        </rdf:RDF>
      </metadata>
      <g
        transform="translate(0.000000,800.000000) scale(0.100000,-0.100000)"
        :fill="defaultFill || '#266fb7'"
        stroke="none"
      >
        <path
          d="M2193 6141 c-87 -22 -168 -101 -193 -191 -6 -22 -10 -633 -10 -1676 0 -1798 -3 -1695 59 -1781 19 -27 51 -51 92 -72 l62 -31 494 0 494 0 24 25 c30 29 31 45 8 74 -18 21 -23 21 -520 23 l-502 3 -36 35 c-19 19 -40 51 -45 71 -7 24 -9 613 -8 1672 3 1634 3 1636 24 1663 11 15 33 37 48 48 27 21 32 21 1156 21 1124 0 1129 0 1156 -21 15 -11 37 -33 48 -48 21 -27 21 -38 24 -704 3 -744 0 -712 63 -712 61 0 59 -23 59 721 l0 676 -31 62 c-30 61 -61 91 -129 127 -34 18 -83 19 -1170 21 -624 0 -1149 -2 -1167 -6z"
        />
        <path
          d="M2423 5750 c-12 -5 -26 -18 -32 -29 -13 -23 -15 -559 -3 -577 20 -30 55 -34 315 -34 241 0 265 2 280 18 14 16 17 55 17 306 1 253 0 291 -15 305 -13 14 -52 16 -278 18 -144 1 -272 -2 -284 -7z m457 -315 l0 -205 -190 0 -190 0 0 198 c0 109 3 202 7 205 3 4 89 7 190 7 l183 0 0 -205z"
        />
        <path
          d="M3147 5631 c-21 -6 -37 -33 -37 -63 0 -57 -4 -56 559 -56 l514 0 24 24 c28 28 29 44 5 74 l-19 23 -516 1 c-285 1 -523 -1 -530 -3z"
        />
        <path
          d="M3153 5342 c-28 -4 -45 -26 -45 -58 0 -57 -18 -55 558 -55 525 1 529 1 547 22 22 27 22 41 -1 69 l-19 23 -509 1 c-280 1 -519 0 -531 -2z"
        />
        <path
          d="M2432 4734 c-27 -19 -29 -64 -4 -87 17 -16 93 -17 885 -17 854 0 867 0 887 20 27 27 26 65 -2 84 -20 14 -120 16 -883 16 -763 0 -863 -2 -883 -16z"
        />
        <path
          d="M4458 4325 c-154 -42 -305 -163 -372 -299 -85 -172 -87 -368 -4 -536 31 -64 140 -185 213 -237 28 -20 29 -22 10 -28 -183 -67 -324 -153 -444 -272 -201 -200 -301 -429 -336 -771 -8 -72 8 -102 54 -102 47 0 52 12 77 168 36 231 92 376 202 520 179 235 410 352 789 402 304 40 512 254 539 553 23 265 -174 534 -441 602 -71 18 -221 18 -287 0z m263 -121 c186 -55 312 -198 338 -382 13 -97 0 -178 -44 -267 -89 -182 -291 -290 -482 -258 -201 35 -355 192 -386 394 -35 228 112 453 334 513 73 20 173 20 240 0z"
        />
        <path
          d="M2427 4252 c-22 -24 -21 -65 1 -85 17 -15 73 -17 595 -17 564 0 577 0 597 20 24 24 25 48 4 78 l-15 22 -583 0 c-552 0 -584 -1 -599 -18z"
        />
        <path
          d="M2450 3753 c-39 -14 -53 -69 -24 -97 14 -14 82 -16 598 -16 552 0 584 1 599 18 24 27 21 58 -9 81 -26 21 -35 21 -588 20 -308 0 -568 -3 -576 -6z"
        />
        <path
          d="M2426 3234 c-32 -31 -10 -94 32 -94 9 0 270 -1 579 -2 536 -2 563 -1 582 16 25 23 26 44 5 74 l-15 22 -584 0 c-517 0 -585 -2 -599 -16z"
        />
        <path
          d="M5238 3166 c-62 -17 -121 -57 -156 -105 l-28 -38 -42 37 c-68 61 -170 76 -252 39 -140 -63 -195 -213 -127 -351 l28 -56 -26 -38 c-25 -36 -25 -39 -25 -247 0 -207 0 -211 25 -254 16 -27 41 -51 66 -64 39 -19 56 -20 375 -19 203 0 345 5 362 11 33 12 92 68 92 86 0 19 12 16 50 -12 44 -33 98 -34 128 -2 21 23 22 31 22 263 0 238 0 241 -23 262 -28 27 -98 30 -117 6 -26 -30 -50 -37 -70 -19 -18 16 -17 18 14 59 111 146 49 359 -126 434 -44 19 -120 23 -170 8z m112 -116 c41 -11 94 -61 109 -103 52 -137 -95 -265 -226 -198 -60 30 -86 78 -81 149 5 69 33 113 92 142 47 23 57 24 106 10z m-436 -64 c64 -27 101 -106 76 -166 -7 -17 -28 -44 -48 -61 -32 -28 -40 -31 -89 -27 -63 5 -107 40 -125 99 -13 44 -6 76 23 114 40 50 103 66 163 41z m510 -398 c13 -18 16 -54 16 -185 0 -154 -1 -163 -22 -188 l-23 -25 -291 -7 c-159 -3 -302 -3 -316 0 -56 14 -58 23 -58 217 0 173 1 179 22 194 19 14 69 16 340 16 316 0 317 0 332 -22z m186 -173 l0 -135 -25 16 c-24 16 -25 21 -25 117 0 79 3 104 17 119 9 10 20 18 25 18 4 0 8 -61 8 -135z"
        />
      </g>
    </svg>
    <svg
      v-if="svgName === 'myWallet'"
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800.000000 800.000000"
      :width="width || '27px'"
      :height="height || '24px'"
      preserveAspectRatio="xMidYMid meet"
    >
      <metadata>
        <rdf:RDF
          xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
          xmlns:rdfs="http://www.w3.org/2000/01/rdf-schema#"
          xmlns:dc="http://purl.org/dc/elements/1.1/"
        >
          <rdf:Description
            dc:format="image/svg+xml"
            dc:Label="1"
            dc:ContentProducer="001191330110MACRLGPT8B00000"
            dc:ProduceID="312386809"
            dc:ReservedCode1="XmoFS8DwUefbtYSAq++IEubNjYehcEVF9nyTly78nRo="
            dc:ContentPropagator="001191330110MACRLGPT8B00000"
            dc:PropagateID="312386809"
            dc:ReservedCode2="XmoFS8DwUefbtYSAq++IEubNjYehcEVF9nyTly78nRo="
          />
        </rdf:RDF>
      </metadata>
      <g
        transform="translate(0.000000,800.000000) scale(0.100000,-0.100000)"
        :fill="defaultFill || '#266fb7'"
        stroke="none"
      >
        <path
          d="M4549 6036 c-2 -2 -78 -6 -169 -10 -647 -25 -1207 -47 -1390 -56 -118 -5 -341 -14 -495 -20 -154 -6 -300 -15 -324 -21 -146 -34 -248 -141 -271 -285 -6 -36 -10 -697 -10 -1696 0 -1782 -2 -1716 55 -1814 33 -56 96 -111 164 -142 52 -24 70 -27 261 -33 354 -13 3238 -3 3290 11 99 26 181 97 229 199 l26 56 3 423 3 422 75 0 c127 0 114 -76 114 655 0 496 -3 635 -12 642 -7 4 -49 7 -93 8 l-80 0 -5 415 -5 415 -27 57 c-32 69 -92 129 -166 165 l-57 28 -1710 5 c-1621 5 -1712 6 -1757 23 -51 20 -114 76 -129 114 -11 29 15 96 48 125 29 26 93 46 170 53 63 5 949 42 1934 80 417 17 417 17 457 -4 60 -30 86 -73 90 -148 l4 -63 79 0 79 0 0 78 c0 92 -19 140 -81 207 -49 53 -97 80 -176 101 -51 13 -115 19 -124 10z m-2443 -690 c11 -8 45 -22 76 -30 50 -15 221 -17 1749 -20 1549 -2 1697 -4 1725 -19 37 -19 82 -70 89 -100 3 -12 4 -197 3 -412 l-3 -390 -555 -5 c-554 -5 -555 -5 -613 -28 -165 -67 -288 -221 -343 -432 -22 -85 -19 -287 5 -383 52 -202 193 -365 372 -429 63 -22 70 -23 602 -26 l537 -3 0 -402 c0 -386 -1 -402 -21 -444 -15 -30 -35 -52 -67 -71 l-47 -27 -1660 -3 c-913 -2 -1683 0 -1711 3 -65 8 -125 46 -156 99 l-23 41 -3 1538 c-1 847 0 1543 4 1548 7 12 16 11 40 -5z m3829 -1621 l0 -480 -630 0 -630 0 -63 34 c-111 60 -189 177 -217 324 -53 277 57 516 273 593 29 10 166 13 652 11 l615 -2 0 -480z"
        />
        <path
          d="M5010 3898 c-24 -13 -58 -40 -74 -61 -29 -36 -31 -45 -31 -116 0 -69 3 -82 28 -118 15 -22 46 -50 68 -62 34 -20 52 -23 113 -19 62 3 79 8 111 32 53 41 78 103 73 182 -3 52 -9 70 -34 101 -39 50 -105 83 -164 83 -28 0 -63 -9 -90 -22z"
        />
      </g>
    </svg>
    <svg
      v-if="svgName === 'address'"
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800.000000 800.000000"
      :width="width || '27px'"
      :height="height || '24px'"
      preserveAspectRatio="xMidYMid meet"
    >
      <metadata>
        <rdf:RDF
          xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
          xmlns:rdfs="http://www.w3.org/2000/01/rdf-schema#"
          xmlns:dc="http://purl.org/dc/elements/1.1/"
        >
          <rdf:Description
            dc:format="image/svg+xml"
            dc:Label="1"
            dc:ContentProducer="001191330110MACRLGPT8B00000"
            dc:ProduceID="312386810"
            dc:ReservedCode1="vg+4H6unoynIVJT+QuqBXAKkg6Fu0K9Xls5h7OcK8kM="
            dc:ContentPropagator="001191330110MACRLGPT8B00000"
            dc:PropagateID="312386810"
            dc:ReservedCode2="vg+4H6unoynIVJT+QuqBXAKkg6Fu0K9Xls5h7OcK8kM="
          />
        </rdf:RDF>
      </metadata>
      <g
        transform="translate(0.000000,800.000000) scale(0.100000,-0.100000)"
        :fill="defaultFill || '#266fb7'"
        stroke="none"
      >
        <path
          d="M3857 6199 c-546 -44 -1005 -396 -1177 -905 -100 -293 -88 -567 41 -994 162 -537 468 -1187 1007 -2135 170 -300 174 -305 220 -305 20 0 43 4 49 8 15 10 228 379 410 712 483 884 771 1577 865 2085 19 104 17 362 -5 460 -59 276 -175 494 -362 680 -141 141 -295 241 -479 309 -131 49 -203 65 -421 89 -22 3 -89 1 -148 -4z m309 -184 c252 -48 469 -167 649 -356 130 -135 230 -319 276 -503 26 -104 36 -320 20 -439 -27 -203 -167 -649 -287 -915 -13 -29 -24 -55 -24 -57 0 -2 -41 -93 -91 -202 -133 -289 -316 -648 -497 -973 -220 -396 -253 -451 -264 -448 -19 7 -343 591 -535 967 -330 642 -566 1258 -619 1615 -42 284 18 567 168 798 257 394 743 601 1204 513z"
        />
        <path
          d="M3835 5590 c-265 -42 -489 -231 -577 -487 -39 -114 -49 -279 -24 -388 53 -228 187 -401 388 -499 357 -174 790 -34 972 314 60 114 80 199 80 330 -1 137 -19 222 -70 323 -124 248 -351 399 -619 412 -49 2 -117 0 -150 -5z m248 -176 c246 -63 427 -289 427 -532 0 -108 -14 -172 -56 -260 -45 -93 -151 -203 -240 -250 -220 -115 -492 -75 -663 97 -226 227 -224 569 4 797 110 110 235 162 389 163 43 1 105 -6 139 -15z"
        />
        <path
          d="M3020 2005 c-14 -15 -23 -37 -23 -55 0 -18 9 -40 23 -55 l23 -25 269 0 c255 0 269 1 288 20 29 29 27 90 -3 118 -23 21 -30 22 -288 22 l-266 0 -23 -25z"
        />
        <path
          d="M4319 2017 c-43 -33 -49 -83 -14 -121 l24 -26 270 0 270 0 20 26 c28 36 27 79 -4 109 l-24 25 -263 0 c-191 -1 -267 -4 -279 -13z"
        />
      </g>
    </svg>
    <svg
      v-if="svgName === 'orderList'"
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800.000000 800.000000"
      :width="width || '27px'"
      :height="height || '24px'"
      preserveAspectRatio="xMidYMid meet"
    >
      <metadata>
        <rdf:RDF
          xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
          xmlns:rdfs="http://www.w3.org/2000/01/rdf-schema#"
          xmlns:dc="http://purl.org/dc/elements/1.1/"
        >
          <rdf:Description
            dc:format="image/svg+xml"
            dc:Label="1"
            dc:ContentProducer="001191330110MACRLGPT8B00000"
            dc:ProduceID="312383743"
            dc:ReservedCode1="GvUCbRLfFE+BfJ8xDQEOeN0h4GnQIL63jSQRmKlDxmk="
            dc:ContentPropagator="001191330110MACRLGPT8B00000"
            dc:PropagateID="312383743"
            dc:ReservedCode2="GvUCbRLfFE+BfJ8xDQEOeN0h4GnQIL63jSQRmKlDxmk="
          />
        </rdf:RDF>
      </metadata>
      <g
        transform="translate(0.000000,800.000000) scale(0.100000,-0.100000)"
        :fill="defaultFill || '#266fb7'"
        stroke="none"
      >
        <path
          d="M3211 6159 c-64 -12 -116 -51 -151 -112 l-30 -52 0 -275 c0 -245 2 -279 19 -315 27 -60 101 -121 162 -134 32 -7 259 -11 639 -11 516 0 595 2 637 16 66 23 105 55 139 116 l29 53 0 270 c0 262 -1 271 -23 317 -13 26 -39 61 -58 77 -68 60 -78 61 -729 60 -324 -1 -610 -5 -634 -10z m1246 -191 c23 -21 23 -24 23 -248 0 -215 -1 -229 -21 -254 l-20 -26 -594 0 c-550 0 -594 1 -614 18 -19 16 -20 28 -22 254 -2 217 -1 240 16 258 18 20 30 20 613 20 l596 0 23 -22z"
        />
        <path
          d="M2363 5792 c-92 -33 -160 -95 -207 -192 l-31 -65 -2 -1495 c-1 -822 2 -1537 7 -1587 7 -75 15 -104 41 -154 52 -98 142 -161 256 -179 70 -12 2729 -12 2820 0 154 19 273 135 302 295 8 41 11 521 11 1565 0 1668 4 1575 -65 1675 -40 59 -87 98 -153 128 -41 19 -69 22 -223 25 l-175 4 -32 -27 c-42 -35 -45 -93 -7 -130 23 -24 28 -25 172 -25 81 0 164 -5 185 -10 45 -13 105 -77 113 -122 3 -18 4 -719 3 -1558 l-3 -1525 -23 -37 c-13 -20 -40 -47 -60 -60 l-37 -23 -1390 -3 c-997 -2 -1401 0 -1430 8 -49 14 -87 44 -111 90 -18 34 -19 92 -22 1535 -2 825 0 1524 3 1553 5 40 15 62 38 89 50 56 76 63 252 63 l157 0 29 29 c36 37 38 79 5 118 l-24 28 -174 2 c-146 3 -181 0 -225 -15z"
        />
        <path
          d="M3034 4728 c-25 -12 -44 -48 -44 -84 0 -37 40 -71 91 -78 24 -4 385 -5 801 -4 l756 3 26 24 c26 24 34 68 20 106 -18 45 -16 45 -846 44 -517 0 -790 -4 -804 -11z"
        />
        <path
          d="M3015 3925 c-17 -16 -25 -35 -25 -60 0 -25 8 -44 25 -60 l24 -25 566 0 567 0 30 30 c26 27 30 36 25 68 -13 76 19 72 -619 72 l-569 0 -24 -25z"
        />
        <path
          d="M3050 3173 c-61 -23 -78 -91 -36 -140 l24 -28 572 0 572 0 24 28 c31 36 31 78 0 114 l-24 28 -559 2 c-307 1 -565 -1 -573 -4z"
        />
      </g>
    </svg>
    <svg
      v-if="svgName === 'associated'"
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800.000000 800.000000"
      :width="width || '27px'"
      :height="height || '24px'"
      preserveAspectRatio="xMidYMid meet"
    >
      <metadata>
        <rdf:RDF
          xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
          xmlns:rdfs="http://www.w3.org/2000/01/rdf-schema#"
          xmlns:dc="http://purl.org/dc/elements/1.1/"
        >
          <rdf:Description
            dc:format="image/svg+xml"
            dc:Label="1"
            dc:ContentProducer="001191330110MACRLGPT8B00000"
            dc:ProduceID="312389280"
            dc:ReservedCode1="xfFWtw3Dsj/7ygbgE+LITqnkwh0+ql1Q2NAwMjdIukE="
            dc:ContentPropagator="001191330110MACRLGPT8B00000"
            dc:PropagateID="312389280"
            dc:ReservedCode2="xfFWtw3Dsj/7ygbgE+LITqnkwh0+ql1Q2NAwMjdIukE="
          />
        </rdf:RDF>
      </metadata>
      <g
        transform="translate(0.000000,800.000000) scale(0.100000,-0.100000)"
        :fill="defaultFill || '#266fb7'"
        stroke="none"
      >
        <path
          d="M2344 6140 c-247 -65 -441 -259 -504 -507 -19 -72 -20 -132 -21 -1536 -2 -1636 -8 -1503 71 -1662 70 -143 178 -248 325 -320 162 -79 80 -75 1639 -75 1110 1 1396 3 1456 14 218 39 400 178 500 381 81 163 75 32 75 1670 0 1628 5 1505 -69 1660 -72 151 -170 251 -321 326 -117 58 -184 69 -431 69 -199 0 -212 -1 -229 -20 -23 -26 -24 -74 -1 -99 16 -17 36 -19 239 -23 208 -4 226 -6 288 -29 94 -36 146 -69 207 -130 61 -62 113 -143 145 -226 l22 -58 3 -1439 c1 -936 -1 -1459 -8 -1495 -5 -31 -28 -94 -51 -140 -70 -141 -201 -253 -350 -295 -50 -15 -198 -16 -1501 -14 l-1445 3 -95 47 c-165 82 -278 225 -314 399 -12 60 -14 273 -12 1492 3 1350 4 1425 21 1477 66 196 229 350 418 395 55 13 207 15 1055 15 978 0 991 0 1009 20 22 25 22 76 -1 101 -17 18 -47 19 -1033 18 -960 0 -1020 -1 -1087 -19z"
        />
        <path
          d="M2986 5449 l-26 -20 0 -309 0 -309 28 -22 c27 -21 31 -21 241 -15 133 4 219 11 228 17 7 6 13 29 13 51 0 58 -31 68 -220 68 l-150 0 0 79 0 80 151 3 c135 3 152 5 165 22 19 27 18 60 -4 79 -13 12 -37 17 -83 17 -35 0 -101 3 -146 7 l-83 6 0 68 0 68 171 3 c155 3 172 5 185 22 19 27 18 70 -4 89 -16 15 -47 17 -229 17 -198 0 -212 -1 -237 -21z"
        />
        <path
          d="M3605 5446 l-25 -25 0 -304 c0 -286 1 -305 19 -321 28 -26 80 -24 103 4 15 19 18 41 18 141 l0 119 53 0 c65 0 67 -2 170 -161 41 -64 82 -119 92 -122 57 -23 101 11 96 74 0 9 -34 66 -74 127 -69 104 -72 112 -53 118 71 22 116 93 116 184 0 73 -31 127 -90 160 -43 24 -55 25 -222 28 l-177 4 -26 -26z m341 -119 c37 -32 37 -79 0 -115 -25 -25 -33 -27 -126 -30 l-100 -4 0 86 0 86 99 0 c90 0 103 -2 127 -23z"
        />
        <path
          d="M4271 5444 c-20 -26 -21 -38 -21 -330 l0 -303 26 -20 c35 -27 59 -26 89 4 24 23 25 31 25 135 l0 110 93 0 c104 0 149 10 198 43 99 67 113 244 26 328 -51 49 -91 59 -259 59 l-157 0 -20 -26z m325 -127 c27 -32 30 -66 10 -106 -20 -38 -55 -51 -141 -51 l-75 0 0 96 0 96 91 -4 c85 -3 92 -5 115 -31z"
        />
        <path
          d="M2772 4507 c-27 -29 -28 -67 -3 -98 l19 -24 1035 0 c1004 0 1036 1 1056 19 29 26 27 71 -4 101 l-24 25 -1029 0 -1029 0 -21 -23z"
        />
        <path
          d="M4076 3938 c-9 -12 -16 -33 -16 -46 0 -13 47 -115 105 -226 58 -112 105 -208 105 -214 0 -7 -34 -12 -97 -14 -96 -3 -98 -4 -111 -31 -17 -35 -4 -77 29 -94 14 -8 66 -13 132 -13 l107 0 0 -50 0 -50 -123 0 c-144 0 -161 -8 -155 -76 4 -54 28 -64 166 -64 l112 0 0 -124 0 -125 45 -7 c25 -3 56 -3 70 0 25 6 25 8 27 114 1 59 2 115 1 125 0 15 12 17 109 17 60 0 118 5 128 10 27 15 36 74 16 105 -16 24 -20 25 -131 25 l-115 0 0 50 0 50 105 0 c99 0 107 2 130 25 30 29 32 64 6 96 -17 21 -29 24 -93 25 -40 1 -79 2 -86 3 -8 1 29 84 99 220 107 210 111 219 98 247 -16 33 -55 50 -92 40 -23 -5 -42 -38 -133 -219 -58 -116 -109 -213 -112 -214 -4 -1 -51 89 -106 199 -54 110 -107 209 -117 219 -27 27 -84 25 -103 -3z"
        />
      </g>
    </svg>
    <svg
      v-if="svgName === 'staff'"
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      :width="width || '27px'"
      :height="height || '24px'"
      viewBox="0 0 800.000000 800.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <metadata>
        <rdf:RDF
          xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
          xmlns:rdfs="http://www.w3.org/2000/01/rdf-schema#"
          xmlns:dc="http://purl.org/dc/elements/1.1/"
        >
          <rdf:Description
            dc:format="image/svg+xml"
            dc:Label="1"
            dc:ContentProducer="001191330110MACRLGPT8B00000"
            dc:ProduceID="313031625"
            dc:ReservedCode1="I826FBn55LrVlxTFJ6A4FaRM1vxNE6XDN2uie9c24UA="
            dc:ContentPropagator="001191330110MACRLGPT8B00000"
            dc:PropagateID="313031625"
            dc:ReservedCode2="I826FBn55LrVlxTFJ6A4FaRM1vxNE6XDN2uie9c24UA="
          />
        </rdf:RDF>
      </metadata>
      <g
        transform="translate(154.592920,659.144422) scale(0.063006,-0.063006)"
        :fill="defaultFill || '#266fb7'"
        stroke="none"
      >
        <path
          d="M3725 7440 c-230 -19 -482 -89 -700 -195 -553 -267 -945 -778 -1071 -1396 -25 -121 -28 -155 -28 -349 0 -237 15 -350 75 -560 169 -590 637 -1083 1223 -1289 349 -123 775 -146 1127 -62 261 62 543 194 751 352 595 453 886 1220 737 1939 -56 275 -201 589 -368 801 -67 84 -162 187 -188 205 -40 25 -93 21 -120 -11 -41 -47 -32 -75 59 -177 251 -285 391 -564 456 -913 26 -143 23 -456 -6 -605 -161 -816 -822 -1401 -1650 -1459 -486 -34 -949 119 -1314 435 -295 254 -499 607 -579 1000 -29 143 -36 412 -15 571 66 502 361 964 801 1254 472 312 1101 375 1632 164 134 -54 162 -56 197 -14 52 61 31 109 -67 153 -268 122 -638 182 -952 156z"
        />
        <path
          d="M3660 3373 c-499 -49 -880 -150 -1265 -338 -344 -168 -606 -353 -874 -618 -320 -317 -573 -703 -752 -1148 -57 -143 -139 -387 -139 -416 0 -13 11 -35 25 -48 l24 -25 1856 0 1857 0 30 30 c47 48 58 23 -185 435 -55 94 -186 313 -290 488 -104 175 -191 326 -194 335 -2 10 64 135 153 287 86 149 200 347 253 440 54 94 139 240 189 327 128 217 125 236 -34 249 -95 8 -582 9 -654 2z m512 -205 c-18 -29 -95 -162 -515 -887 -70 -121 -101 -184 -101 -206 0 -22 37 -93 131 -251 71 -120 192 -325 268 -454 76 -129 153 -257 170 -285 17 -27 42 -67 54 -87 l23 -38 -1680 0 -1680 0 48 128 c70 183 112 280 189 428 166 317 334 545 577 786 481 474 1113 776 1824 873 151 20 172 21 463 23 l249 2 -20 -32z"
        />
        <path
          d="M4901 3353 c-12 -10 -43 -56 -69 -103 -27 -47 -87 -150 -133 -230 -47 -80 -136 -232 -197 -337 -62 -106 -162 -279 -223 -384 -75 -129 -111 -201 -112 -223 -1 -36 6 -49 278 -521 365 -635 427 -740 447 -757 19 -17 70 -18 767 -18 l748 0 20 22 c19 21 55 81 232 388 37 63 164 282 284 486 119 204 217 379 217 388 0 19 -18 57 -65 136 -19 30 -173 298 -345 595 -171 297 -320 548 -332 558 -19 16 -70 17 -758 17 -688 0 -739 -1 -759 -17z m1435 -195 c9 -18 47 -85 84 -148 36 -63 101 -173 142 -245 41 -71 148 -255 237 -407 88 -152 161 -282 161 -288 0 -12 -87 -164 -360 -630 -92 -157 -193 -329 -224 -382 l-57 -98 -663 0 -664 0 -70 123 c-38 67 -129 226 -202 352 -74 127 -186 322 -250 434 l-117 205 97 165 c83 142 453 779 527 909 l25 42 659 0 658 0 17 -32z"
        />
        <path
          d="M5535 2640 c-214 -43 -395 -214 -450 -427 -20 -75 -19 -209 1 -287 41 -160 158 -304 305 -375 103 -49 150 -60 254 -61 172 0 309 55 424 170 77 76 124 158 151 266 37 144 24 266 -43 403 -72 149 -220 268 -378 306 -68 16 -197 18 -264 5z m261 -192 c102 -37 184 -114 232 -214 24 -53 27 -70 27 -169 0 -101 -2 -115 -29 -170 -80 -162 -268 -259 -439 -227 -178 33 -306 162 -339 342 -38 203 124 425 335 459 69 10 150 3 213 -21z"
        />
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    svgName: {
      type: String,
      default: "",
      required: true
    },
    width: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: ""
    },
    defaultFill: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.svg-box {
  display: inline-block;
}
svg {
  // path {
  //   fill: var(--color-primary-light10);
  // }
  &:hover {
    path {
      fill: var(--color-primary-dark10);
    }
  }
}
</style>
